import type { Status } from '../common/types';
import type { UserRelation } from '../user/types';

export enum BasicRecordEnum {
  OWN = 'Own',
  AFFILIATED = 'Affiliated',
}

export interface ProductT {
  product_id: string;
  production_type: string[];
}

// Mirrors corp-frontend-v2 services/src/lib/models/holding.model.ts (Holding class). Class-based in
// Angular, plain interface in React — fields kept optional + snake_case to match backend payload.
export interface Holding {
  count_farms?: number;
  created_date?: string;
  id?: string;
  name?: string;
  status?: Status | string;
  status_sync?: string;
  type?: string;
  updated_date?: string;
  products?: ProductT[];
  products_t?: ProductT[];
  is_super_holding?: boolean | number;
  modules?: string[];
  basic_record?: BasicRecordEnum;
  users_relations?: UserRelation[];
}
